// extracted by mini-css-extract-plugin
module.exports = {"root":"admin_root__1reGa","nav":"admin_nav__3-FLj","content":"admin_content__19c6Q"};